import type { VoiceImprovementScript, VoiceProfileView } from '@alterium/shared';
import { api } from './client';

export const voiceApi = {
  get: () => api.get<VoiceProfileView>('/persona/voice'),
  improvementScript: () => api.get<VoiceImprovementScript>('/persona/voice/improvement-script'),
  start: () => api.post<VoiceProfileView>('/persona/voice'),
  improve: (assetId: string, scriptVersion?: string) =>
    api.post<VoiceProfileView>('/persona/voice/improve', {
      assetId,
      ...(scriptVersion ? { scriptVersion } : {}),
    }),
  remove: () => api.delete('/persona/voice'),
};
